import styled from 'styled-components';

import { control } from '../../styles/mixins';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  background-color: var(--surface-2);

  > div {
    background-color: var(--surface);
    padding: 4rem;
    border-radius: var(--r-md);
    box-shadow: var(--shadow-lg);
    max-width: 500px;
    width: 100%;
    border: 1px solid var(--border);
  }

  h2 {
    text-align: center;
    margin-bottom: 3.2rem;
    color: var(--ink);
    font-size: 2.8rem;
    font-weight: 700;
  }

  @media (max-width: 600px) {
    > div {
      padding: 2.4rem;
      margin: 0.8rem;
    }

    h2 {
      font-size: 2.4rem;
    }
  }
`;

export const Form = styled.form``;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.6rem;
  margin-bottom: 2.4rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;

  &.full-width {
    grid-column: 1 / -1;
  }

  /* Escopado no filho direto: o SelectDropdown vive aqui dentro e monta
     labels de opção em <span> e um <input> invisível de acessibilidade, que
     não podem herdar o estilo de rótulo nem o de campo. */
  > label,
  > span {
    font-weight: 600;
    margin-bottom: 0.8rem;
    color: var(--ink-soft);
    font-size: 1.25rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  > input {
    ${control}
    padding: 1.2rem;
    font-size: 1.6rem;

    &:hover {
      border-color: var(--ink-faint);
    }
  }

  > input[type='number'] {
    text-align: center;
    appearance: textfield;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const Preview = styled.div`
  margin: 3.2rem 0;
  padding: 5rem 2rem;
  background-color: var(--surface-2);
  border: 2px dashed var(--border-strong);
  border-radius: var(--r-md);
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-family: ${props => props.fontFamily || 'Arial'} !important;
  color: var(--ink);
  transition: border-color var(--dur-fast) var(--ease-standard);

  &:hover {
    border-color: var(--accent);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1.6rem;
  margin-top: 2.4rem;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const BaseButton = styled.button`
  flex: 1;
  font-weight: 700;
  height: 6rem;
  border: 1px solid transparent;
  border-radius: var(--r-pill);
  transition: background-color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 1.5rem;
  color: #fff;

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &:disabled {
    background-color: var(--surface-2);
    border-color: var(--border);
    color: var(--ink-faint);
    cursor: not-allowed;
  }
`;

export const SendButton = styled(BaseButton)`
  background-color: var(--success);

  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

export const RecordButton = styled(BaseButton)`
  background-color: var(--accent);

  &:hover:not(:disabled) {
    background-color: var(--accent-deep);
  }
`;
